var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product",staticStyle:{"height":"100%","width":"100%","position":"absolute"}},[_c('div',{staticClass:"vue-padding radius",staticStyle:{"height":"96%","width":"98%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://doc.chuanyisoft.com/?g=Doc&m=Article&a=index&id=7","frameborder":"0"}})])])
}]

export { render, staticRenderFns }